
import { Component, Vue, Prop } from 'vue-property-decorator';
import type { IAttributeCardPoint, ICardMemberModel } from '@pazion/pazion-catalog/src/models/member_card.model';
import CanvasPlotAttribute from "../atoms/CanvasPlotAttributeElement.vue";
import dayjs from "dayjs";

@Component({
  components: {
    CanvasPlotAttribute
  }
})
export default class CardDesignAttributeBlock extends Vue {

  @Prop() point!: IAttributeCardPoint;
  @Prop() viewPlotType!: boolean;
  @Prop() hasToken!: boolean;
  @Prop() setStyle?: string;
  @Prop() dynamicKey?: string | null;
  @Prop() showPointText?: boolean;
  @Prop() currentMember?: ICardMemberModel;
  @Prop() clientView?: boolean;

  get showImage(): boolean {
    if(this.point.system == 'logo'){
      return this.hasToken; //only show logo when logged in
    }
    return true;
  }

  get getFinalValue() {
    return (this.point.isMemberAttr && this.currentMember)
      ? this.currentMember[this.point.text] : this.point.value;
  }

  getKeyValue(value: string) {
    const parsedArray = (value && [...JSON.parse(value)]);
    if (this.dynamicKey) {
      const preparingValue = parsedArray && parsedArray.find(pa => pa && pa.key === this.dynamicKey);
      return preparingValue && preparingValue.value;
    } else {
      return parsedArray && typeof parsedArray === 'object' && parsedArray.length && parsedArray[0].value
    }
  }

  get datetimeFormated() {
    return dayjs(this.point.value).isValid() ? dayjs(this.point.value).format('D-M-YYYY') : this.point.value;
  }

  get getImageValue() {
    return this.point.value && typeof this.point.value === 'string' ? this.point.value : null
  }

}//
